import styled from 'styled-components'
import { fontWeights, colors, breakpoints } from '@/styles'

const EmailLink = styled.a`
  font-weight: ${fontWeights.medium};
  font-size: 16px;
  line-height: 24px;
  color: ${colors.link};
  margin: 0;
  @media screen and (max-width: ${breakpoints.tabletLandscape}) {
    font-size: 14px;
  }
`

type EmailLinkProps = { email: string }

const EmailLinkComponent: React.FC<EmailLinkProps> = ({ email }) => {
  return (
    <EmailLink href={`mailto:${email}`} target="_blank" rel="noopener noreferrer">
      {email}
    </EmailLink>
  )
}

export default EmailLinkComponent
